export default __webpack_public_path__ + "3f145a65e90f47dd23e410ea34ca6520.svg";